export enum MessageSeverity {
  Error = 'ERROR',
  Information = 'INFORMATION',
  Success = 'SUCCESS',
  Warning = 'WARNING',
}

export enum MessageType {
  DiscountShipping = 'DISCOUNT_SHIPPING',
  DiscountSitewide = 'DISCOUNT_SITEWIDE',
  DiscountVolume = 'DISCOUNT_VOLUME',
  ExpiredProductRemoval = 'EXPIRED_PRODUCT_REMOVAL',
  FlatRateShippingApplied = 'FLAT_RATE_SHIPPING_APPLIED',
  FreeShippingOnProductApplied = 'FREE_SHIPPING_ON_PRODUCT_APPLIED',
  NonsaleableProductRemoval = 'NONSALEABLE_PRODUCT_REMOVAL',
  ProductWarning = 'PRODUCT_WARNING',
}

export interface Message {
  severity: MessageSeverity;
  type?: MessageType;
  actionUrl?: string;
  applied?: boolean;
  productName?: string;
  text?: string;
  itemId?: string;
}
